/**
 * 環境変数が有効か？
 * @param envItem
 * @returns true:有効
 */
export function isEnabledEnv(envItem: number|string|undefined): boolean {
  return ( envItem === 1 || envItem === 'true' || envItem === 'TRUE');
}
